<template>
  <div class="overlay">
    <!-- Display after selecting Help button -->
    <v-container fluid grid-list-md>
      <v-layout>
        <v-flex xs6>
          <h1>Question {{ question.questionIndex }} Help</h1>
        </v-flex>
        <v-flex xs5></v-flex>
        <v-flex xs1 style="padding-right: 10px;">
          <v-icon v-on:click="onCloseHelpClicked">fa fa-times fa-3x fa-pull-right</v-icon>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <hr />
        </v-flex>
      </v-layout>
    </v-container>

    <p></p>
  </div>
</template>

<script>
export default {
  name: "WesHelpPanel",
  props: {
    question: Object
  },
  methods: {
    onCloseHelpClicked: function (val) {
      // this.display = val;
      this.$emit("closepanel");
    }
  }
};
</script>

<style scoped>
.overlay {
  position: absolute;
  overflow: hidden;
  border: 2px solid #13314f;
  border-radius: 5px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: block;
  z-index: 10;
  background-color: #eeeeee;
  color: #13314f;
}
.question-number.hide {
  display: none;
}
</style>
